<template>
<div>
    <div class="col-xs-12 col-md-12 push">

        <div v-if="mainService.service_invoices.length > 0" class="table-responsive push">
            <table class="table table-striped table-vcenter">
                <thead>
                    <tr>
                        <th class="text-center" style="width: 25%;">{{invoiceColumn01[actualLanguage]}}</th>
                        <th class="text-center" style="width: 15%;">{{invoiceColumn02[actualLanguage]}}</th>
                        <th class="text-center" style="width: 15%;">{{invoiceColumn03[actualLanguage]}}</th>
                        <th class="text-center" style="width: 15%;">{{invoiceColumn04[actualLanguage]}}</th>
                        <th class="text-center" style="width: 15%;">{{invoiceColumn05[actualLanguage]}}</th>
                        <th class="text-center" style="width: 15%;">{{invoiceColumn06[actualLanguage]}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for= "(invoice,index) in mainService.service_invoices">
                        <td class="text-center font-w600">
                          {{invoice.referenceNumber}}
                        </td>
                        <td class="text-center font-w600">
                            {{invoice.dateStartStr}}               
                        </td>
                        <td class="text-center font-w600">
                            {{invoice.dateEndStr}}              
                        </td>

                        <td class="text-center font-w600">
                            {{invoice.amount}}
                        </td>
                        <td class="text-center font-w600">
                            {{invoice.tax}}
                        </td>
                        <td class="text-center font-w600">
                            {{invoice.total}}
                        </td>
                    </tr>

                </tbody>
            </table>

        </div>


    </div>


    <div v-if="flagAddInvoice" class="col-xs-12 col-md-12 push">
      <div class="content content-boxed">
        <div class="block block-bordered">
          <div  class="block-content">
            <div class="row">
              <h2 class="block-title push">{{labelAddInvoiceTitle[actualLanguage]}}</h2>

              <div class="col-xs-12 col-sm-4">
                  <h6>{{labelReference[actualLanguage]}}</h6>
                  <input v-model="tempoInvoiceReferenceNumber" class="form-control align-center" type="test"  placeholder="">
              </div>

              <div class="col-xs-12 col-sm-4">
                <h6>{{labelDateStart[actualLanguage]}}</h6>
                <div class="input-daterange form-group row">
                    <div class="input-date-time-picker" >
                      <date-picker
                          class="el-input__inner form-control"
                          v-model="tempoInvoiceDateStart"
                          type="date"
                          placeholder=""
                          clear-icon=""
                          format="yyyy-MM-dd"
                          value-format="timestamp"
                      />
                    </div>
                </div>
              </div>

              <div class="col-xs-12 col-sm-4">
                <h6>{{labelDateEnd[actualLanguage]}}</h6>
                <div class="input-daterange form-group row">
                    <div class="input-date-time-picker" >
                      <date-picker
                          class="el-input__inner form-control"
                          v-model="tempoInvoiceDateEnd"
                          type="date"
                          placeholder=""
                          clear-icon=""
                          format="yyyy-MM-dd"
                          value-format="timestamp"
                      />
                    </div>
                </div>
              </div>

              <div class="col-xs-12 col-sm-4">
                  <h6>{{labelAmount[actualLanguage]}}</h6>
                  <input @click="computeAmountTotal()" v-model="tempoAmount" class="form-control align-center" type="test"  placeholder="">
              </div>

              <div class="col-xs-12 col-sm-4">
                  <h6>{{labelTax[actualLanguage]}}</h6>
                  <input @click="computeAmountTotal()" v-model="tempoTax" class="form-control align-center" type="test"  placeholder="">
              </div>

              <div class="col-xs-12 col-sm-4">
                  <h6>{{labelTotal[actualLanguage]}}</h6>
                  {{tempoAmountWithTax}}
              </div>

              <div class="col-xs-12 col-sm-12">
                <h6 style="color:white;">-</h6>
                <button  type="button" @click="addInvoiceStep01()" class="btn btn-default align-right push" name="buttonAddPlanItem">
                <spinner size="small" v-if="invoiceIsSaving01"></spinner>
                <span v-else><i class="fa fa-floppy-o fa-1x push-5-r "></i>{{ labelButtonSaveInvoice[actualLanguage] }}</span></button>

                <button  type="button" @click="toggleAddInvoice()" class="btn btn-default align-left" name="buttonAddPlanItem">
                <i class="fa fa-times fa-1x push-5-r "></i>{{ labelButtonCancel[actualLanguage] }}</button> 
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="col-xs-12 col-md-12 push">
        <button  type="button" @click="toggleAddInvoice()" class="btn btn-default align-right" name="buttonAddPlanItem">
        <i class="fa fa-plus fa-1x push-5-r "></i>{{ labelButtonAddInvoice[actualLanguage] }}</button>                         
    </div>


</div>

</template>


<script>

import Spinner from '@/components/Spinner'

import {mapState, mapActions, mapGetters} from 'vuex'
import { DatePicker, TimePicker, TimeSelect } from 'element-ui';
import moment from 'moment';

export default {
  name: 'GroupIndex',
  props: ['mainService'],

  data() {
    return {
      flagDisplayBanner : 0,
      flagDisplayDetail : 0,
      invoiceIsSaving01 : false,
      serviceIsDeleting:false,
      actualLanguage : "FR",

      invoiceColumn01: {FR: "Numéro de référence", EN: 'Reference number'},
      invoiceColumn02: {FR: "Date début", EN: 'Date start'},
      invoiceColumn03: {FR: "Date de fin", EN: 'Date end'},
      invoiceColumn04: {FR: "Montant ($)", EN: 'Amount ($)'},
      invoiceColumn05: {FR: "Taxes ($)", EN: 'Tax ($)'},
      invoiceColumn06: {FR: "Total ($)", EN: 'Total ($)'},


      labelTitleSectionInvoices: {FR: "Factures du service", EN: 'Service invoices'},
      labelButtonAddInvoice: {FR: "Ajouter une facture", EN: 'Add invoice'},
      labelButtonSaveInvoice: {FR: "Enregistrer la facture", EN: 'Save invoice'},
      labelButtonCancel: {FR: "Annuler", EN: 'Cancel'},
      flagAddInvoice : 0,
      labelAddInvoiceTitle: {FR: "Details de la facture", EN: 'Service Invoice details'},
      labelReference: {FR: "Numero de référence", EN: 'Reference number'},
      labelDateStart: {FR: "Date début", EN: 'Date start'},
      labelDateEnd: {FR: "Date fin", EN: 'Date end'},
      labelAmount: {FR: "Montant ($)", EN: 'Amount ($)'},
      labelTax: {FR: "Taxes ($)", EN: 'Tax ($)'},
      labelTotal: {FR: "Total ($)", EN: 'Total ($)'},

      labelButtonSaveInvoice: {FR: "Enregistrer la facture", EN: 'Save invoice'},
      tempoInvoiceReferenceNumber : '',
      tempoInvoiceDateStart:'',
      tempoInvoiceDateEnd:'',
      tempoAmount:'0',
      tempoTax:'0',
      tempoAmountWithTax:'',

      saveInvoiceConfirmationMessage: {FR: "Informations validées, confirmer l'enregistrement de cette facture. ATTENTION CETTE OPÉRATION NE PEUT SE FAIRE QU'UNE SEULE FOIS!",
                               EN: 'Information validated, confirm the recording of this invoice. CAUTION THIS OPERATION CAN ONLY BE DONE ONCE!'},

    }
  },
  components: {
    Spinner,
    DatePicker,
    TimePicker,
    TimeSelect
  },
  computed: {
    ...mapState('sessionStore', ['userEmail','profileData','planTransactionData','actualBundle','parentContainer']),
  },

  methods: {
    ...mapActions('overlayStore', ['showModal']),


    toggleAddInvoice(){
      this.flagAddInvoice = ~this.flagAddInvoice
    },

    addInvoiceStep01(){
        
        console.log(response)
    },

    addInvoiceStep01(){
        this.computeAmountTotal()

        var requestData = {'postAction':'ValidateMainServiceInvoice',
                          'bundleId':this.actualBundle.bundle_id,
                          'parentContainer':this.parentContainer,
                          'mainServiceId':this.mainService.service_id,
                          'invoiceReferenceNumber':this.tempoInvoiceReferenceNumber,
                          'invoiceDateStart':this.tempoInvoiceDateStart,
                          'invoiceDateEnd':this.tempoInvoiceDateEnd,
                          'invoiceAmount':this.tempoAmount,
                          'invoiceTax':this.tempoTax,
                          'invoiceTotal':this.tempoAmountWithTax}
        this.invoiceIsSaving01=true
        this.$store.dispatch('sessionStore/postBundle', requestData)
            .then((response) => {
              //console.log(requestData)
            if(response.data.Code=='OK'){
                this.invoiceIsSaving01=false
                var response = window.confirm(this.saveInvoiceConfirmationMessage[this.actualLanguage])
                if(response){
                  this.addInvoiceStep02()
                }
                }
                else{
                  window.alert(response.data.PromptMessage[this.actualLanguage])
                  this.invoiceIsSaving01=false
                  }
            })
    },

    addInvoiceStep02(){
        var requestData = {'postAction':'AddMainServiceInvoice',
                          'bundleId':this.actualBundle.bundle_id,
                          'parentContainer':this.parentContainer,
                          'mainServiceId':this.mainService.service_id,
                          'invoiceReferenceNumber':this.tempoInvoiceReferenceNumber,
                          'invoiceDateStart':this.tempoInvoiceDateStart,
                          'invoiceDateEnd':this.tempoInvoiceDateEnd,
                          'invoiceAmount':this.tempoAmount,
                          'invoiceTax':this.tempoTax,
                          'invoiceTotal':this.tempoAmountWithTax}
        this.invoiceIsSaving01=true
        this.$store.dispatch('sessionStore/postBundle', requestData)
            .then((response) => {
              //console.log(response)
            if(response.data.Code=='OK'){
                this.invoiceIsSaving01=false
                this.mainService.service_invoices = response.data.ServiceInvoice
                this.flagAddInvoice = 0
                }
                else{
                  window.alert(response.data.PromptMessage[this.actualLanguage])
                  this.invoiceIsSaving01=false
                  }
            })
    },

    computeAmountTotal(){
      var total = parseFloat(this.tempoAmount)+parseFloat(this.tempoTax)      
      this.tempoAmountWithTax = total.toFixed(2).toString()
    },

    returnToMyServicePlan(){
      this.planTransactionData.transactionStatusCode = '000'
      this.flagDisplayPlan = 0
      window.scrollTo(0, 0)
    },



    },

  mounted() {

    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}
  }
}
</script>





// WEBPACK FOOTER //
// MainServiceDisplayTabInvoices.vue?141cedde